export interface Faq {
  q: string;
  a: string;
  category: string;
}

export const faqs: Faq[] = [
  {
    category: '追更提醒',
    q: '如何开启漫画的连载更新提醒？',
    a: '在我爱漫画网收藏你正在追更的漫画后，进入「我的收藏」页面，找到对应作品，点击「开启提醒」即可。开启后，每当该漫画更新新话，系统会在设定的时间通过站内通知或消息推送第一时间告诉你，不错过任何一话。',
  },
  {
    category: '追更提醒',
    q: '更新提醒的推送时间可以自己设置吗？',
    a: '可以。在「提醒设置」中，你可以选择即时推送、每日定时推送或仅在指定日期接收更新提醒。所有已收藏漫画的更新动态，都会汇总进你的追漫日历，一目了然。',
  },
  {
    category: '追更提醒',
    q: '多部漫画同时更新时会漏提醒吗？',
    a: '不会。我爱漫画网会对所有已开启提醒的漫画进行集中管理，即使同一天有多部作品更新，也会按顺序汇总成一条通知推送给你，并在追漫日历上分别标注，确保每部都记录在案。',
  },
  {
    category: '收藏与进度',
    q: '「养肥再看」和进度保存是什么意思？',
    a: '对于连载中的长篇漫画，你可以先收藏并开启提醒，等它积累更多章节后一次性通读，这就是「养肥再看」。系统会自动保存你读到的最新一话，下次打开直接从上次位置继续，无需手动记录。',
  },
  {
    category: '收藏与进度',
    q: '进度保存在不同设备上会同步吗？',
    a: '当你登录账号后，阅读进度会自动云端同步，手机、平板、电脑之间无缝衔接。你可以随时在追漫日历上查看每部作品的「已读进度」和「待读章节」，跨设备追更更省心。',
  },
  {
    category: '收藏与进度',
    q: '取消收藏会删除我的阅读进度吗？',
    a: '取消收藏只会将作品从你的收藏列表中移除，已保存的阅读进度仍然保留。之后重新收藏该漫画，进度会恢复，方便你回来看完整部作品。',
  },
  {
    category: '追漫日历',
    q: '追漫日历上能查看哪些信息？',
    a: '追漫日历按周展示所有已收藏漫画的更新日期与时间，包括每部作品最新更新到第几话、距离下一话还有几天，以及本周待读章节数量，帮助你合理安排阅读节奏。',
  },
  {
    category: '追漫日历',
    q: '我爱漫画网的追更收藏服务收费吗？',
    a: '基础功能——收藏漫画、连载更新提醒、追漫日历和进度保存目前均为免费开放。我们坚持让每个漫画迷都能方便地管理自己的追更清单，未来若有增值功能会提前公告并保持透明。',
  },
];